import { render, staticRenderFns } from "./expertExtractionFrom.vue?vue&type=template&id=6358a819&scoped=true"
import script from "./expertExtractionFrom.vue?vue&type=script&lang=js"
export * from "./expertExtractionFrom.vue?vue&type=script&lang=js"
import style0 from "./expertExtractionFrom.vue?vue&type=style&index=0&id=6358a819&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6358a819",
  null
  
)

export default component.exports